import { render, staticRenderFns } from "./recycleBin.vue?vue&type=template&id=5d33e129&scoped=true"
import script from "./recycleBin.vue?vue&type=script&lang=js"
export * from "./recycleBin.vue?vue&type=script&lang=js"
import style0 from "./recycleBin.vue?vue&type=style&index=0&id=5d33e129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d33e129",
  null
  
)

export default component.exports